import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const MODELS = [
  {
    n: "01",
    title: "Dine-In Restaurants",
    copy: "Four flagship outlets across Ranchi's busiest corridors — multi-cuisine kitchens that built our name since 2010.",
    img: "/images/north.jpg",
    to: "/restaurants",
    testid: "model-card-restaurants",
  },
  {
    n: "02",
    title: "Cloud Kitchen Network",
    copy: "Five specialised delivery brands, live on Zomato, Swiggy & WhatsApp — all from one shared kitchen.",
    img: "/images/biryani.jpg",
    to: "/cloud-kitchen",
    testid: "model-card-cloud-kitchen",
  },
  {
    n: "03",
    title: "Hospital Canteens",
    copy: "Recurring B2B contracts feeding patients, doctors and staff across nine hospitals, around the clock.",
    img: "/images/canteen.jpg",
    to: "/hospital-canteen",
    testid: "model-card-hospital-canteen",
  },
];

export default function ModelsOverview() {
  return (
    <section data-testid="models-overview" className="bg-cream px-5 pb-24 pt-6 text-obsidian sm:px-8 lg:pb-32">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <FadeUp className="lg:col-span-7">
            <span className="font-mono text-xs uppercase tracking-[0.35em] text-flame">The Three Engines</span>
            <h2 className="mt-4 font-display text-2xl font-semibold leading-[1.12] tracking-tight sm:text-3xl lg:text-4xl" data-testid="models-overview-headline">
              Pick an engine.{" "}
              <span className="font-serif italic font-medium text-flame">See how it runs.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.12} className="flex items-end lg:col-span-5">
            <p className="text-base leading-relaxed text-slate-600">
              Each model has its own page — the outlets, the brands, the contracts.
              Dive into whichever engine interests you most.
            </p>
          </FadeUp>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3" data-testid="models-overview-grid">
          {MODELS.map((m, i) => (
            <FadeUp key={m.testid} delay={i * 0.1}>
              <Link
                to={m.to}
                data-testid={m.testid}
                className="group relative block h-[24rem] overflow-hidden rounded-3xl transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_28px_70px_rgba(224,90,43,0.25)]"
              >
                <img
                  src={m.img}
                  alt={m.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/95 via-obsidian/40 to-obsidian/15" />
                <span className="absolute left-5 top-5 rounded-full bg-white/10 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-cream backdrop-blur-sm">
                  {m.n}
                </span>
                <div className="absolute inset-x-5 bottom-5">
                  <h3 className="font-display text-2xl font-semibold tracking-tight text-cream">{m.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{m.copy}</p>
                  <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-saffron">
                    Explore
                    <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
